// HeroSlider.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, EffectFade } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import { Link } from "react-router-dom";

const slides = [
  "assets/images/daily/v2.png",
  "assets/images/daily/v3.png",
  "assets/images/daily/5.png",
];

const HeroSlider = () => {
  return (
    <div className="pbmit-slider-area pbmit-slider-one">
      <Swiper
        modules={[Autoplay, Navigation, EffectFade]}
        loop={true}
        effect="fade"
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        navigation={true}
        className="pbmit-swiper-slider"
      >
        {slides.map((img, index) => (
          <SwiperSlide key={index}>
            <div className="pbmit-slider-item">
              <div
                className="pbmit-slider-bg"
                style={{
                  backgroundImage: `url('${img}')`,
                }}
              ></div>
              <div className="container">
                <div className="row">
                  <div className="col-md-9">
                    <div className="pbmit-slider-content">
                     
                      <h2 className="pbmit-title transform-left transform-delay-2">
                        Build the physical capacity behind your best
                        performance.
                      </h2>

                      <h5 className="pbmit-sub-title transform-top transform-delay-1">
                        A discipline led performance system that starts with
                        physical capacity and develops habits, focus, and
                        execution.
                      </h5>
                      <br />
                      <div className="pbmit-buttom-area transform-bottom transform-delay-3">
                        <Link
                          to="/fitness/#pricing"
                          className="pbmit-btn pbmit-btn-white m-2"
                        >
                          <span className="button-text">
                            Start 3 days Trial
                          </span>
                        </Link>

                        <Link
                          to="/performance"
                          className="pbmit-btn pbmit-btn-white m-2"
                        >
                          <span className="button-text">
                            Explore Performance
                          </span>
                        </Link>
                        {/* <div className="pbmit-number">
                          20000<span>+</span>
                        </div>
                        <div className="pbmit-text">Active Transformations</div> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4"></div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HeroSlider;
